<template>
  <!-- 封装弹框 -->
  <div class="popup">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="visible"
      :width="width"
      :before-close="handleClose"
    >
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Cancel">取 消</el-button>
        <el-button type="primary" :disabled="disabledval" @click="Save">{{ saveTitle }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 传入标题
    title: {
      type: String,
      default: '标题',
    },
    // 弹窗是否展示
    visible: {
      type: Boolean,
      default: false,
    },
    // 弹窗宽度
    width: {
      type: String,
      default: '400px',
    },
    // 确定按钮的文字
    saveTitle: {
      type: String,
      default: '确定',
    },
    // 确认按钮是否被禁用
    disabledval: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val);
      },
    },
  },
  methods: {
    Cancel() {
      this.$emit('resetPopupData');
    },
    Save() {
      this.$emit('submitPopupData');
    },
    handleClose() {
      this.$emit('handleClose');
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
